import React, { useRef, useState } from 'react';
import { FlaskConical, Loader2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { Button } from '../../components/ui/button';
import { Pill } from '../../components/common';

export function PromptTestRun({ docId, prompt }) {
  const app = useApp();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const noProvider = app.settings.ai.activeProvider === 'none';
  const run = async (e) => {
    const f = e.target.files?.[0]; e.target.value = '';
    if (!f || !docId) return;
    setBusy(true); setRes(null);
    const r = await app.extractTest(docId, f, prompt);
    setRes({ ...r, file: f.name });
    setBusy(false);
  };
  return (
    <div className="rounded-lg border border-dashed border-line bg-paper-50 p-3 space-y-2" data-testid="prompt-test-run">
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs text-ink-600"><span className="font-medium text-ink-800">Test this prompt</span> on a sample PDF or image — nothing is stored.{!docId && ' Save the document type first.'}{noProvider && ' No AI provider configured.'}</div>
        <input ref={ref} type="file" accept="application/pdf,image/png,image/jpeg,image/webp" className="hidden" onChange={run} data-testid="prompt-test-file" />
        <Button type="button" size="sm" variant="outline" data-testid="prompt-test-button" disabled={busy || !docId || noProvider} onClick={() => ref.current?.click()}>{busy ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <FlaskConical className="h-3.5 w-3.5 mr-1.5" />}{busy ? 'Extracting…' : 'Try on a file'}</Button>
      </div>
      {res && (
        <div data-testid="prompt-test-result">
          <div className="flex flex-wrap items-center gap-1.5 text-[11px] text-ink-500 mb-1.5"><Pill tone={res.ok ? 'emerald' : 'rose'} data-testid="prompt-test-status">{res.ok ? 'extracted' : 'failed'}</Pill>{res.provider && <span>{res.provider}{res.model ? ` · ${res.model}` : ''}</span>}{res.ms != null && <span>· {res.ms} ms</span>}<span>· {res.file}</span></div>
          {res.error && <div className="text-xs text-rose-700 mb-1.5">{res.error}</div>}
          {res.result && <pre data-testid="prompt-test-json" className="max-h-56 overflow-auto whitespace-pre-wrap text-[11px] font-mono text-ink-800 bg-white border border-line rounded-md p-2">{JSON.stringify(res.result, null, 2)}</pre>}
        </div>
      )}
    </div>
  );
}
